import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';

import authReducer from '~/thunks/auth/authSlice';
import masterReducer from '~/thunks/master/masterSlice';
import jobReducer from '~/thunks/job/jobSlice';
import timeClockReducer from '~/thunks/time-clocks/timeClocksSlice';
import jobTypeReducer from '~/thunks/job-type/jobTypeSlice';
import tagReducer from '~/thunks/tag/tagSlice';
import accountReducer from '~/thunks/account/accountSlice';
import scheduleReducer from '~/thunks/schedule/scheduleSlice';
import franchiseReducer from '~/thunks/franchise/franchiseSlice';
import taskReducer from '~/thunks/task/taskSlice';
import dashboardReducer from '~/thunks/dashboard/dashboardSlice';
import quickbookReducer from '~/thunks/quickbook/quickbookSlice';
import priceComponentReducer from '~/thunks/price-components/priceComponentsSlice';
import priceReducer from '~/thunks/price/pricesSlice';
import priceItemReducer from '~/thunks/price-item/priceItemsSlice';
import customerReducer from '~/thunks/customer/customerSlice';
import commonSearchReducer from '~/thunks/common-search/commonSearchSlice';
import templateReducer from '~/thunks/template/templateSlice';
import locationReducer from '~/thunks/location/locationSlice';
import estimateReducer from '~/thunks/estimate/estimateSlice';
import googleReducer from '~/thunks/google/googleSlice';
import activityReducer from '~/thunks/activity/activitySlice';
import folderReducer from '~/thunks/folder/folderSlice';
import notificationReducer from '~/thunks/notification/notificationSlice';
import companyReducer from '~/thunks/company/companySlice';
import invoiceReducer from '~/thunks/invoice/invoiceSlice';
import reportReducer from '~/thunks/report/reportSlice';
import estimateTemplateReducer from '~/thunks/estimate-template/estimateTemplateSlice';
import companyRoleReducer from '~/thunks/company-role/companyRoleSlice';
import areaScopeReducer from '~/thunks/areaScope/areaScopeSlice';
import equipmentReducer from '~/thunks/equipment/equipmentSlice';
import jobStatusReducer from '~/thunks/job-status.ts/jobStatusSlice';
import campaignReducer from '~/thunks/campaign/campaignSlice';
import ringCentralReducer from '~/thunks/ring-central/ringCentralSlice';
import cogsReducer from '~/thunks/cogs/cogsSlice';
import crmStatusReducer from '~/thunks/crm-status/crmStatusSlice';
import commonReducer from '~/thunks/common/commonSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  master: masterReducer,
  job: jobReducer,
  timeClocks: timeClockReducer,
  jobType: jobTypeReducer,
  tag: tagReducer,
  account: accountReducer,
  schedule: scheduleReducer,
  franchise: franchiseReducer,
  task: taskReducer,
  dashboard: dashboardReducer,
  quickbook: quickbookReducer,
  priceComponent: priceComponentReducer,
  price: priceReducer,
  priceItem: priceItemReducer,
  customer: customerReducer,
  commonSearch: commonSearchReducer,
  template: templateReducer,
  location: locationReducer,
  estimate: estimateReducer,
  google: googleReducer,
  activity: activityReducer,
  folder: folderReducer,
  notification: notificationReducer,
  company: companyReducer,
  invoice: invoiceReducer,
  report: reportReducer,
  estimateTemplate: estimateTemplateReducer,
  companyRole: companyRoleReducer,
  areaScope: areaScopeReducer,
  equipment: equipmentReducer,
  jobStatus: jobStatusReducer,
  crmStatus: crmStatusReducer,
  campaign: campaignReducer,
  ringCentral: ringCentralReducer,
  cogs: cogsReducer,
  common: commonReducer,
});

export function makeStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
    devTools: process.env.NODE_ENV !== 'production',
  });
}

const store = makeStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export default store;
